import { useDataSource } from '../../../../../lib/dataSource'
import { useLifeSpaceTasks } from '../../../hooks/useLifeSpaceTasks'
import { keepWhileParentListed, useListedChildren } from '../../../hooks/useListedChildren'
import type { ListedTask } from '../../../utils/taskToEntryData'


/**
 * Die Aufgaben der Seite **Wiederkehrend** in einem Lebensbereich: jede mit **Wiederholung**,
 * ruhend oder nicht (`isRecurringTask`). **Erledigte kommen mit** — wie auf Ruhend blendet die
 * Seite sie erst nach der **Liegezeit** aus, sonst verschwände die Zeile unter dem Haken.
 * Unsortiert — die Seite gruppiert.
 *
 * **Wiederkehrende Unteraufgaben** (#205) stehen als eigene Rhythmen da, mit dem Titel ihrer
 * Aufgabe davor.
 */
export function useRecurringTasks({ lifeSpace, isActive }: {
  lifeSpace: 'personal' | 'work' | 'home'
  isActive: boolean
}): ListedTask[] | undefined {
  return useListedChildren(useLifeSpaceTasks(lifeSpace, useDataSource().useRecurringTasks(isActive)), keepWhileParentListed)
}
